import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/company'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(company, uuid) {
    return http.put(`${resource}/${uuid}`, company)
  },
  add(company) {
    return http.post(`${resource}`, company)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
